export default __webpack_public_path__ + "static/media/multiasset-banner-invest.d8716116.jpg";